import { render, staticRenderFns } from "./TermBooklist.vue?vue&type=template&id=8a6061da"
import script from "./TermBooklist.vue?vue&type=script&lang=js"
export * from "./TermBooklist.vue?vue&type=script&lang=js"
import style0 from "./TermBooklist.vue?vue&type=style&index=0&id=8a6061da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports